import DrawerOuter45 from './drawer-icon/outer_45.svg';
import DrawerOuter90 from './drawer-icon/outer_90.svg';
import DrawerOuter135 from './drawer-icon/outer_135.svg';
import DrawerOuter0 from './drawer-icon/outer_0.svg';
import DrawerOuter0Phai from './drawer-icon/outer_0_phai.svg';
import DrawerOuter180 from './drawer-icon/outer_180.svg';
import DrawerOuter225 from './drawer-icon/outer_225.svg';
import DrawerOuter270 from './drawer-icon/outer_270.svg';
import DrawerOuter315 from './drawer-icon/outer_315.svg';

import DrawerInner45 from './drawer-icon/inner_45.svg';
import DrawerInner90 from './drawer-icon/inner_90.svg';
import DrawerInner135 from './drawer-icon/inner_135.svg';
import DrawerInner0 from './drawer-icon/inner_0.svg';
import DrawerInner0Phai from './drawer-icon/inner_0_phai.svg';
import DrawerInner180 from './drawer-icon/inner_180.svg';
import DrawerInner225 from './drawer-icon/inner_225.svg';
import DrawerInner270 from './drawer-icon/inner_270.svg';
import DrawerInner315 from './drawer-icon/inner_315.svg';

import DrawerPerspective1 from './drawer-icon/perspective_1.svg';
import DrawerPerspective2 from './drawer-icon/perspective_2.svg';
import DrawerPerspective3 from './drawer-icon/perspective_3.svg';
import DrawerPerspective4 from './drawer-icon/perspective_4.svg';
import DrawerPerspective5 from './drawer-icon/perspective_5.svg';

import DrawerEMPTY from './drawer-icon/empty.svg';

import { EMPTY_EFFECT } from '../../preset-util/base-preset-util';
import NoEffectFill from '@tencent/docs-design-resources/icon/desktop/svg/no_effect_fill_44.svg';
import OuterOffsetBottomRightFill from '@tencent/docs-design-resources/icon/desktop/svg/outer_offset_bottom_right_fill_44.svg';
import OuterOffsetDownFill from '@tencent/docs-design-resources/icon/desktop/svg/outer_offset_down_fill_44.svg';
import OuterOffsetBottomLeftFill from '@tencent/docs-design-resources/icon/desktop/svg/outer_offset_bottom_left_fill_44.svg';
import OuterOffsetRightFill from '@tencent/docs-design-resources/icon/desktop/svg/outer_offset_right_fill_44.svg';
import OuterOffsetCenterFill from '@tencent/docs-design-resources/icon/desktop/svg/outer_offset_center_fill_44.svg';
import OuterOffsetLeftFill from '@tencent/docs-design-resources/icon/desktop/svg/outer_offset_left_fill_44.svg';
import OuterOffsetTopRightFill from '@tencent/docs-design-resources/icon/desktop/svg/outer_offset_top_right_fill_44.svg';
import OuterOffsetUpFill from '@tencent/docs-design-resources/icon/desktop/svg/outer_offset_up_fill_44.svg';
import OuterOffsetTopLeftFill from '@tencent/docs-design-resources/icon/desktop/svg/outer_offset_top_left_fill_44.svg';
import InnerLeftUpFill from '@tencent/docs-design-resources/icon/desktop/svg/inner_left_up_fill_44.svg';
import InnerUpFill from '@tencent/docs-design-resources/icon/desktop/svg/inner_up_fill_44.svg';
import InnerRightUpFill from '@tencent/docs-design-resources/icon/desktop/svg/inner_right_up_fill_44.svg';
import InnerLeftFill from '@tencent/docs-design-resources/icon/desktop/svg/inner_left_fill_44.svg';
import InnerCenterFill from '@tencent/docs-design-resources/icon/desktop/svg/inner_center_fill_44.svg';
import InnerRightFill from '@tencent/docs-design-resources/icon/desktop/svg/inner_right_fill_44.svg';
import InnerDownLeftFill from '@tencent/docs-design-resources/icon/desktop/svg/inner_down_left_fill_44.svg';
import InnerDownFill from '@tencent/docs-design-resources/icon/desktop/svg/inner_down_fill_44.svg';
import InnerDownRightFill from '@tencent/docs-design-resources/icon/desktop/svg/inner_down_right_fill_44.svg';
import PerspectiveTopLeftFill from '@tencent/docs-design-resources/icon/desktop/svg/perspective_top_left_fill_44.svg';
import PerspectiveTopRightFill from '@tencent/docs-design-resources/icon/desktop/svg/perspective_top_right_fill_44.svg';
import PerspectiveDownFill from '@tencent/docs-design-resources/icon/desktop/svg/perspective_down_fill_44.svg';
import PerspectiveBottomLeftFill from '@tencent/docs-design-resources/icon/desktop/svg/perspective_bottom_left_fill_44.svg';
import PerspectiveBottomRightFill from '@tencent/docs-design-resources/icon/desktop/svg/perspective_bottom_right_fill_44.svg';

import ShapeNoEffectFill from '@tencent/docs-design-resources/icon/desktop/svg/shape_noeffect_44.svg';
import ShapeOuterOffsetBottomRightFill from '@tencent/docs-design-resources/icon/desktop/svg/shape_external_offset_bottom_right_44.svg';
import ShapeOuterOffsetDownFill from '@tencent/docs-design-resources/icon/desktop/svg/shape_external_offset_bottom_44.svg';
import ShapeOuterOffsetBottomLeftFill from '@tencent/docs-design-resources/icon/desktop/svg/shape_external_offset_bottom_left_44.svg';
import ShapeOuterOffsetRightFill from '@tencent/docs-design-resources/icon/desktop/svg/shape_external_offset_right_44.svg';
import ShapeOuterOffsetCenterFill from '@tencent/docs-design-resources/icon/desktop/svg/shape_external_offset_center_44.svg';
import ShapeOuterOffsetLeftFill from '@tencent/docs-design-resources/icon/desktop/svg/shape_external_offset_left_44.svg';
import ShapeOuterOffsetTopRightFill from '@tencent/docs-design-resources/icon/desktop/svg/shape_external_offset_top_right_44.svg';
import ShapeOuterOffsetUpFill from '@tencent/docs-design-resources/icon/desktop/svg/shape_external_offset_top_44.svg';
import ShapeOuterOffsetTopLeftFill from '@tencent/docs-design-resources/icon/desktop/svg/shape_external_offset_top_left_44.svg';
import ShapeInnerLeftUpFill from '@tencent/docs-design-resources/icon/desktop/svg/shape_internal_top_left_44.svg';
import ShapeInnerUpFill from '@tencent/docs-design-resources/icon/desktop/svg/shape_internal_top_44.svg';
import ShapeInnerRightUpFill from '@tencent/docs-design-resources/icon/desktop/svg/shape_internal_top_right_44.svg';
import ShapeInnerLeftFill from '@tencent/docs-design-resources/icon/desktop/svg/shape_internal_left_44.svg';
import ShapeInnerCenterFill from '@tencent/docs-design-resources/icon/desktop/svg/shape_internal_center_44.svg';
import ShapeInnerRightFill from '@tencent/docs-design-resources/icon/desktop/svg/shape_internal_right_44.svg';
import ShapeInnerDownLeftFill from '@tencent/docs-design-resources/icon/desktop/svg/shape_internal_bottom_left_44.svg';
import ShapeInnerDownFill from '@tencent/docs-design-resources/icon/desktop/svg/shape_internal_bottom_44.svg';
import ShapeInnerDownRightFill from '@tencent/docs-design-resources/icon/desktop/svg/shape_internal_bottom_right_44.svg';
import ShapePerspectiveTopLeftFill from '@tencent/docs-design-resources/icon/desktop/svg/shape_perspective_top_left_44.svg';
import ShapePerspectiveTopRightFill from '@tencent/docs-design-resources/icon/desktop/svg/shape_perspective_top_right_44.svg';
import ShapePerspectiveDownFill from '@tencent/docs-design-resources/icon/desktop/svg/shape_perspective_bottom_44.svg';
import ShapePerspectiveBottomLeftFill from '@tencent/docs-design-resources/icon/desktop/svg/shape_perspective_bottom_left_44.svg';
import ShapePerspectiveBottomRightFill from '@tencent/docs-design-resources/icon/desktop/svg/shape_perspective_bottom_right_44.svg';

import TextNoEffectFill from '@tencent/docs-design-resources/icon/desktop/svg/text_noeffect_44.svg';
import TextOuterOffsetBottomRightFill from '@tencent/docs-design-resources/icon/desktop/svg/text_external_offset_bottom_right_44.svg';
import TextOuterOffsetDownFill from '@tencent/docs-design-resources/icon/desktop/svg/text_external_offset_bottom_44.svg';
import TextOuterOffsetBottomLeftFill from '@tencent/docs-design-resources/icon/desktop/svg/text_external_offset_bottom_left_44.svg';
import TextOuterOffsetRightFill from '@tencent/docs-design-resources/icon/desktop/svg/text_external_offset_right_44.svg';
import TextOuterOffsetCenterFill from '@tencent/docs-design-resources/icon/desktop/svg/text_external_offset_center_44.svg';
import TextOuterOffsetLeftFill from '@tencent/docs-design-resources/icon/desktop/svg/text_external_offset_left_44.svg';
import TextOuterOffsetTopRightFill from '@tencent/docs-design-resources/icon/desktop/svg/text_external_offset_top_right_44.svg';
import TextOuterOffsetUpFill from '@tencent/docs-design-resources/icon/desktop/svg/text_external_offset_top_44.svg';
import TextOuterOffsetTopLeftFill from '@tencent/docs-design-resources/icon/desktop/svg/text_external_offset_top_left_44.svg';
import TextInnerLeftUpFill from '@tencent/docs-design-resources/icon/desktop/svg/text_internal_top_left_44.svg';
import TextInnerUpFill from '@tencent/docs-design-resources/icon/desktop/svg/text_internal_top_44.svg';
import TextInnerRightUpFill from '@tencent/docs-design-resources/icon/desktop/svg/text_internal_top_right_44.svg';
import TextInnerLeftFill from '@tencent/docs-design-resources/icon/desktop/svg/text_internal_left_44.svg';
import TextInnerCenterFill from '@tencent/docs-design-resources/icon/desktop/svg/text_internal_center_44.svg';
import TextInnerRightFill from '@tencent/docs-design-resources/icon/desktop/svg/text_internal_right_44.svg';
import TextInnerDownLeftFill from '@tencent/docs-design-resources/icon/desktop/svg/text_internal_bottom_left_44.svg';
import TextInnerDownFill from '@tencent/docs-design-resources/icon/desktop/svg/text_internal_bottom_44.svg';
import TextInnerDownRightFill from '@tencent/docs-design-resources/icon/desktop/svg/text_internal_bottom_right_44.svg';
import TextPerspectiveTopLeftFill from '@tencent/docs-design-resources/icon/desktop/svg/text_perspective_top_left_44.svg';
import TextPerspectiveTopRightFill from '@tencent/docs-design-resources/icon/desktop/svg/text_perspective_top_right_44.svg';
import TextPerspectiveDownFill from '@tencent/docs-design-resources/icon/desktop/svg/text_perspective_bottom_44.svg';
import TextPerspectiveBottomLeftFill from '@tencent/docs-design-resources/icon/desktop/svg/text_perspective_bottom_left_44.svg';
import TextPerspectiveBottomRightFill from '@tencent/docs-design-resources/icon/desktop/svg/text_perspective_bottom_right_44.svg';

export {
    DrawerOuter45,
    DrawerOuter90,
    DrawerOuter135,
    DrawerOuter0,
    DrawerOuter0Phai,
    DrawerOuter180,
    DrawerOuter225,
    DrawerOuter270,
    DrawerOuter315,
    DrawerInner45,
    DrawerInner90,
    DrawerInner135,
    DrawerInner0,
    DrawerInner0Phai,
    DrawerInner180,
    DrawerInner225,
    DrawerInner270,
    DrawerInner315,
    DrawerPerspective1,
    DrawerPerspective2,
    DrawerPerspective3,
    DrawerPerspective4,
    DrawerPerspective5,
    DrawerEMPTY,
};


export const SHAPE_PRESET_ICONS = {
    [EMPTY_EFFECT]: ShapeNoEffectFill,
    'outer-45': ShapeOuterOffsetBottomRightFill,
    'outer-90': ShapeOuterOffsetDownFill,
    'outer-135': ShapeOuterOffsetBottomLeftFill,
    'outer-0': ShapeOuterOffsetRightFill,
    'outer-0-phai': ShapeOuterOffsetCenterFill,
    'outer-180': ShapeOuterOffsetLeftFill,
    'outer-225': ShapeOuterOffsetTopLeftFill,
    'outer-270': ShapeOuterOffsetUpFill,
    'outer-315': ShapeOuterOffsetTopRightFill,
    'inner-45': ShapeInnerDownRightFill,
    'inner-90': ShapeInnerDownFill,
    'inner-135': ShapeInnerDownLeftFill,
    'inner-0': ShapeInnerRightFill,
    'inner-0-phai': ShapeInnerCenterFill,
    'inner-180': ShapeInnerLeftFill,
    'inner-225': ShapeInnerLeftUpFill,
    'inner-270': ShapeInnerUpFill,
    'inner-315': ShapeInnerRightUpFill,
    'perspective-1': ShapePerspectiveTopLeftFill,
    'perspective-2': ShapePerspectiveTopRightFill,
    'perspective-3': ShapePerspectiveDownFill,
    'perspective-4': ShapePerspectiveBottomLeftFill,
    'perspective-5': ShapePerspectiveBottomRightFill,
};

export const IMAGE_PRESET_ICONS = {
    [EMPTY_EFFECT]: NoEffectFill,
    'outer-45': OuterOffsetBottomRightFill,
    'outer-90': OuterOffsetDownFill,
    'outer-135': OuterOffsetBottomLeftFill,
    'outer-0': OuterOffsetRightFill,
    'outer-0-phai': OuterOffsetCenterFill,
    'outer-180': OuterOffsetLeftFill,
    'outer-225': OuterOffsetTopLeftFill,
    'outer-270': OuterOffsetUpFill,
    'outer-315': OuterOffsetTopRightFill,
    'inner-45': InnerDownRightFill,
    'inner-90': InnerDownFill,
    'inner-135': InnerDownLeftFill,
    'inner-0': InnerRightFill,
    'inner-0-phai': InnerCenterFill,
    'inner-180': InnerLeftFill,
    'inner-225': InnerLeftUpFill,
    'inner-270': InnerUpFill,
    'inner-315': InnerRightUpFill,
    'perspective-1': PerspectiveTopLeftFill,
    'perspective-2': PerspectiveTopRightFill,
    'perspective-3': PerspectiveDownFill,
    'perspective-4': PerspectiveBottomLeftFill,
    'perspective-5': PerspectiveBottomRightFill,
};

export const TEXT_PRESET_ICONS = {
    [EMPTY_EFFECT]: TextNoEffectFill,
    'outer-45': TextOuterOffsetBottomRightFill,
    'outer-90': TextOuterOffsetDownFill,
    'outer-135': TextOuterOffsetBottomLeftFill,
    'outer-0': TextOuterOffsetRightFill,
    'outer-0-phai': TextOuterOffsetCenterFill,
    'outer-180': TextOuterOffsetLeftFill,
    'outer-225': TextOuterOffsetTopLeftFill,
    'outer-270': TextOuterOffsetUpFill,
    'outer-315': TextOuterOffsetTopRightFill,
    'inner-45': TextInnerDownRightFill,
    'inner-90': TextInnerDownFill,
    'inner-135': TextInnerDownLeftFill,
    'inner-0': TextInnerRightFill,
    'inner-0-phai': TextInnerCenterFill,
    'inner-180': TextInnerLeftFill,
    'inner-225': TextInnerLeftUpFill,
    'inner-270': TextInnerUpFill,
    'inner-315': TextInnerRightUpFill,
    'perspective-1': TextPerspectiveTopLeftFill,
    'perspective-2': TextPerspectiveTopRightFill,
    'perspective-3': TextPerspectiveDownFill,
    'perspective-4': TextPerspectiveBottomLeftFill,
    'perspective-5': TextPerspectiveBottomRightFill,
};

